import ErrorMessage from 'lib/ErrorMessage'
import React from 'react'
import "./index.scss"
import Table from './Table'

const RadioQuestion = (props) => {
    const { options, label, sublabel, onChange, name, tablecontent, table, value, error, question, title, content, questionnaireId,riskProfile,
        isEditable // is used when RM requests to resend certain fields to the applicant
        // when editable is true only that field will be editable and rest will be disabled
       } = props

    const errActive = error && error?.length !== 0;
    const errorClass = errActive ? "error_outline" : ""
    const IndirectEval = (item) => {
        return eval(item);
      };
    
    return (
        <div className={riskProfile ? `card_container card_container_disabled`:`card_container ${errorClass}`}>
            <p>{title}</p>
            <label className='question_label'>{question}</label>
            {content ?  <div className="table table-responsive"  dangerouslySetInnerHTML={{__html: IndirectEval(content)}} /> : content}            {
                options?.map((option, index) => {
                    const { id, label } = option
                    let radioId = name + id

                    return (
                        <div className='radio_options' key={radioId}>
                            <input
                                id={radioId}
                                type="radio"
                                name={name}
                                className={`option_input ${!isEditable && "radioDisabled"}`}
                                onChange={(e) => onChange(e, label, question, props.id, questionnaireId,content,id)}
                                value={option.score}
                                checked={value && value?.id?.includes(option?.id) ? true : false}
                                disabled = {isEditable ? false:true}
                            />
                            <label className='option_label' htmlFor={radioId}>
                                {label}
                            </label>
                        </div>
                    )
                })
            }

            {
                error?.length !== 0 && (
                    <ErrorMessage error={error} />
                )
            }
        </div>
    )
}

export default RadioQuestion